module.exports = __webpack_public_path__ + "img/nav7.f41e344e.png";